// Module
var code = "<div class=\"language-selector__icon\"></div> <a href=\"#en\" data-lang=\"en\" class=\"language-selector__text uppercase\">ita</a> ";
// Exports
export default code;